module.exports = __webpack_public_path__ + "img/xizang.70401d0e.jpg";